module.exports = __webpack_public_path__ + "static/media/Bell_beaker_eba_scotland.c819ebed.png";